import React from "react";
import { Clock, Users, DollarSign, ChevronRight, CircleCheck } from "lucide-react";
import Card from "components/card";
import Button from "components/button";

const LocationCard = ({
    flag,
    country,
    city,
    timezone,
    population,
    salaryRange,
    selected = false,
    theme,
    onClick,
}) => {

    const InfoRow = ({ icon, text }) => (
        <div className="flex items-center gap-2 text-slate-700">
            <span className="flex-shrink-0">{icon}</span>
            <span className="truncate">{text}</span>
        </div>
    );

    return (
        <Card
            onClick={onClick}
            className={`
                flex flex-col gap-6 rounded-2xl cursor-pointer
                border-2 transition-all duration-300
                shadow-lg hover:shadow-xl
                text-slate-900
                border-slate-200 hover:border-slate-300
                ${selected ? `location-theme ${theme} bg location-theme ${theme} border` : "bg-white border-current"}
            `}
        >
            <div className="p-4 sm:p-6">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                        <span className="text-4xl sm:text-5xl">{flag}</span>
                        <div>
                        <h3 className="text-[16px] sm:text-[18px] font-semibold">{country}</h3>
                        {city && (
                            <p className="text-[11px] sm:text-[12px] text-slate-700">{city}</p>
                        )}
                        </div>
                    </div>

                    {selected && (
                        <CircleCheck
                        className="
                            w-5 h-5 sm:w-6 sm:h-6
                            bg-clip-text text-transparent
                        "
                        />
                    )}
                </div>

                <div className="space-y-2 text-[11px] sm:text-[12px]">
                    <InfoRow icon={<Clock className="w-3 h-3" />} text={timezone} />
                    <InfoRow icon={<Users className="w-3 h-3" />} text={population}/>
                    <InfoRow icon={<DollarSign className="w-3 h-3" />} text={salaryRange}/>
                </div>

                <Button
                    className={`
                        w-full mt-4 h-8 sm:h-9
                        rounded-lg px-4 text-[12px] sm:text-[13px]
                        font-medium text-white 
                        location-theme ${theme} button
                        hover:opacity-90 transition-all
                        hover:shadow-none
                        inline-flex items-center justify-center gap-2
                    `}
                >
                    View Details
                    <ChevronRight className="w-3 h-3 sm:w-4 sm:h-4" />
                </Button>
            </div>
        </Card>
    );
};

export default LocationCard;
